import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Panel } from '../ui/Modal';

export function NotFound() {
  const { t } = useTranslation();
  return (
    <div style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', padding: 16 }}>
      <Panel style={{ padding: 28, textAlign: 'center', maxWidth: 420 }}>
        <h2 style={{ color: 'var(--gold-strong)', marginBottom: 12 }}>404</h2>
        <p>{t('common.notFound')}</p>
        <Link to="/">{t('common.goHome')}</Link>
      </Panel>
    </div>
  );
}
